"use strict";

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var network_1 = require("./network");

var tokens_1 = require("./tokens");

var kTokenToAddressMap = new Map([[network_1.Network.Mainnet, new Map([[tokens_1.Token.ETH, "0x5E2Aac57939D2f37B95b20ED700264580B369292"], [tokens_1.Token.USDC, "0x042996A909F2915B57B8066c8aEe768831533463"], [tokens_1.Token.DAI, "0x9897092389f9FBF5c166E0Ee87cB3AB9718359fA"]])], [network_1.Network.Ropsten, new Map([[tokens_1.Token.ETH, "0x5Ada1962dB38D728022D9c398BC1f233ebb9F4A2"], [tokens_1.Token.USDC, "0xf173798254a5B4BD7b859d9A0eeDc1201Df98B38"], [tokens_1.Token.DAI, "0x42d471DCb91bC44b20c7671DBE76709fADF6F5f8"]])], [network_1.Network.Rinkeby, new Map([[tokens_1.Token.ETH, "0x7Af75395A3b5f9618698AF3ACD3c4A99751f009e"], [tokens_1.Token.USDC, "0x7Ba5903ad15feb2FBA4155241Fd8588B814F564b"], [tokens_1.Token.DAI, "0x826644DF9AfF4f9De7D55A950FDF63fD68D66EF9"]])]]);
var addressToKTokenMap = new Map(Array.from(kTokenToAddressMap.entries()).map(function (kv) {
  return [kv[0], new Map(Array.from(kv[1].entries()).map(function (kv) {
    return [kv[1], kv[0]];
  }))];
}));

var KTokenUtils =
/** @class */
function () {
  function KTokenUtils() {}

  KTokenUtils.getAddress = function (network, token) {
    if (!kTokenToAddressMap.has(network)) {
      return null;
    }

    if (!kTokenToAddressMap.get(network).has(token)) {
      return null;
    }

    return kTokenToAddressMap.get(network).get(token);
  };

  KTokenUtils.fromAddress = function (network, kTokenAddress) {
    if (!addressToKTokenMap.has(network)) {
      return null;
    }

    if (!addressToKTokenMap.get(network).has(kTokenAddress)) {
      return null;
    }

    return addressToKTokenMap.get(network).get(kTokenAddress);
  };

  return KTokenUtils;
}();

exports.KTokenUtils = KTokenUtils;